import React, { useCallback } from "react";
import useCreateTestPackage from "./useCreateTestPackage";
import { useTranslation } from "react-i18next";
import CreateTestPackageForm from "../form/CreateTestPackageForm";
import APP_ROUTES from "src/routes/routes";
import { useSearchParams } from "react-router-dom";

export const FORM_NAME = {
  ID: "id",
  TITLE: "title",
  YAMCS_PACKAGE_ID: "yamcs_package_id",
  PLAN_START_DATE: "plan_start_date",
};

const NewTestPackage = () => {
  const { t } = useTranslation("test-package");
  const { submitData } = useCreateTestPackage();
  let [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const condition = searchParams.get("condition");
  const instanceId = searchParams.get("instanceId");

  const getRedirectURL = useCallback(() => {
    const params = new URLSearchParams();
    if (page) params.set("page", page);
    if (condition) params.set("condition", condition);
    if (instanceId) params.set("instanceId", instanceId);

    const queryString = params.toString();
    return `${APP_ROUTES.TEST_PACKAGE}${queryString ? "?" + queryString : ""}`;
  }, [page, condition, instanceId]);

  const data = {
    [FORM_NAME.ID]: "",
    [FORM_NAME.TITLE]: "",
    [FORM_NAME.YAMCS_PACKAGE_ID]: [],
    [FORM_NAME.PLAN_START_DATE]: "",
  };

  return <CreateTestPackageForm submitData={submitData} data={data} title={t("new.title")} getRedirectURL={getRedirectURL} />;
};

export default NewTestPackage;
